<div class="settings-search">
  <div class="settings-search-field d-flex align-items-center gap-2 px-3">
    <i class="lnr lnr-magnifier text-muted" aria-hidden="true"></i>
    <input
      #searchInput
      class="form-control form-control-lg border-0 shadow-none px-0"
      id="settings-search-input"
      type="text"
      role="combobox"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      aria-autocomplete="list"
      [attr.aria-controls]="listboxId"
      [attr.aria-expanded]="results.length > 0"
      [attr.aria-activedescendant]="activeOptionId"
      [attr.aria-label]="'SETTINGS.SEARCH.TITLE' | translate"
      [attr.placeholder]="'SETTINGS.SEARCH.PLACEHOLDER' | translate"
      [ngModel]="query"
      (ngModelChange)="onQueryChange($event)"
      (keydown)="onKeydown($event)"
    />
    <button
      class="btn-close"
      type="button"
      [attr.aria-label]="'BUTTONS.CLOSE' | translate"
      (click)="close()"
    ></button>
  </div>
  <ul
    class="settings-search-results list-unstyled mb-0"
    role="listbox"
    [id]="listboxId"
    [attr.aria-label]="'SETTINGS.SEARCH.TITLE' | translate"
  >
    @for (r of results; track trackByResult(r); let i = $index) {
      <li
        class="settings-search-result d-flex align-items-center gap-3 px-3 py-2"
        role="option"
        [id]="optionId(i)"
        [attr.aria-selected]="i === activeIndex"
        [class.active]="i === activeIndex"
        (mouseenter)="activeIndex = i"
        (click)="select(r)"
      >
        <div class="settings-search-result-text flex-grow-1">
          <div class="settings-search-result-title" [innerHTML]="titleHtml(r)"></div>
          @if (r.description) {
            <div class="small text-muted text-truncate">
              {{ r.description }}
            </div>
          }
        </div>
        <span
          class="badge rounded-pill text-bg-light text-secondary fw-normal flex-shrink-0"
          >{{ r.tabLabel | titlecase }}</span
        >
      </li>
    }
  </ul>
  @if (!query) {
    <p
      class="settings-search-empty text-muted small text-center mb-0 px-3 py-4"
    >
      {{ 'SETTINGS.SEARCH.HINT' | translate }}
    </p>
  }
  @if (query && results.length === 0) {
    <p
      class="settings-search-empty text-muted small text-center mb-0 px-3 py-4"
    >
      {{ 'SETTINGS.SEARCH.NO_RESULTS' | translate: { query: query } }}
    </p>
  }
  <div
    class="settings-search-footer d-flex align-items-center flex-wrap gap-3 px-3 py-2 small text-muted"
  >
    <span
      ><kbd>↑</kbd><kbd>↓</kbd>
      {{ 'SETTINGS.SEARCH.KEYS.NAVIGATE' | translate }}</span
    >
    <span><kbd>↵</kbd> {{ 'SETTINGS.SEARCH.KEYS.OPEN' | translate }}</span>
    <span><kbd>esc</kbd> {{ 'SETTINGS.SEARCH.KEYS.CLOSE' | translate }}</span>
    <span class="ms-auto" role="status" aria-live="polite">
      @if (query && results.length > 0) {
        {{
          (isCapped
            ? 'SETTINGS.SEARCH.TOP_RESULTS'
            : 'SETTINGS.SEARCH.RESULTS_COUNT'
          ) | translate: { count: results.length }
        }}
      }
    </span>
  </div>
</div>
